export default "__VITE_ASSET__ba2b0238__"